import styled from "styled-components";

export const Container = styled.div`
  padding-top: 16px;
  padding-bottom: 32px;
  width: 100%;
  margin: 0 auto;
  max-width: 700px;

  h1 {
    color: #2d2d2d;
    text-align: center;
    font-family: Mulish;
    font-size: 20px;
    font-style: normal;
    font-weight: 800;
    line-height: 24px;
    margin-bottom: 32px;
  }

  @media (min-width: 640px) {
    padding-top: 120px;
  }
`;

export const SectionTitle = styled.h2`
  color: #9d9d9d;
  font-family: Mulish;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  margin-bottom: 32px;
  text-align: center;

  @media (min-width: 640px) {
    margin-bottom: 36px;
  }
`;

export const Grid1 = styled.div`
  margin-bottom: 32px;
  display: grid;
  gap: 24px;

  @media (min-width: 640px) {
    grid-template-columns: 1fr 1fr;

    > :nth-child(1) {
      grid-column: span 2;
    }
    > :nth-child(2) {
      grid-column: span 1;
    }
    > :nth-child(3) {
      grid-column: span 1;
    }
    > :nth-child(4) {
      grid-column: span 2;
    }
  }
`;

export const Grid2 = styled.div`
  margin-bottom: 32px;
  display: grid;
  gap: 24px;

  @media (min-width: 640px) {
    grid-template-columns: 1fr 1fr;

    > :nth-child(1) {
      grid-column: span 1;
    }
    > :nth-child(2) {
      grid-column: span 1;
    }
    > :nth-child(3) {
      grid-column: span 2;
    }
  }
`;

export const Grid3 = styled.div`
  margin-bottom: 32px;
  display: grid;
  gap: 24px;
`;

export const Card = styled.div`
  border-radius: 10px;
  background: #f7f7f7;
  padding: 16px 8px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  p {
    color: #9d9d9d;
    font-family: Mulish;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 0.42px;
    text-transform: capitalize;

    span {
      font-weight: 400;
    }
  }
`;

export const FlexItems = styled.div`
  margin-bottom: 32px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Flex = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  p {
    color: #9d9d9d;
    font-family: Mulish;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
  }

  @media (min-width: 640px) {
    flex-direction: row;
    align-items: center;
  }
`;

export const Flex1 = styled.div`
  margin-bottom: 32px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Flex2 = styled.div`
  margin-bottom: 32px;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
`;

export const ToBack = styled.button`
  color: #2d2d2d;
  display: block;
  width: fit-content;
  text-align: center;
  font-family: Mulish;
  background-color: transparent;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  text-decoration-line: underline;
  margin: 32px auto;
`;

export const Anonimo = styled.div`
  width: 100%;
  margin-bottom: 2rem;
  > div {
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      font-family: Mulish;
      color: #9d9d9d !important;
    }
  }
`;